// extracted by mini-css-extract-plugin
export default {"container":"AppList_container__noWrS","title":"AppList_title__pz96u","list":"AppList_list__0siwd"};